/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 11th 2022, 7:23:00 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { DesignLayout, DesignLayoutValidationSchema } from "lib/schemas";
import { APISERVICEPATHS, useAPIForm, UseAPIFormSpec } from "lib/api";
import { PrimaryKeyValue } from "lib/types";

const designLayoutAPIServicePath = APISERVICEPATHS.designLayouts;

const useDesignLayoutAPIForm = (
  designLayoutID: PrimaryKeyValue<DesignLayout>,
  onSuccessfulAPISave: UseAPIFormSpec<DesignLayout>["setAPIFormResponse"],
  newDesignLayoutDefault: DesignLayout
) => {
  const useDesignLayoutAPIFormReturn = useAPIForm({
    apiFormDefaultValues: newDesignLayoutDefault,
    apiFormDataValidationSchema: DesignLayoutValidationSchema,
    apiInitialFetchId: designLayoutID,
    apiServicePath: designLayoutAPIServicePath,
    setAPIFormResponse: onSuccessfulAPISave,
    primaryKey: "id",
    formResetDependencyArray: [designLayoutID],
    successNotificationMessage: "Design Layout saved successfully",
  });

  return { useDesignLayoutAPIFormReturn };
};

export const useDesignLayoutAPI = () => ({
  useDesignLayoutAPIForm,
});
